import { createMetaRoute } from '@funtech-int/rival';

import { RouteMeta } from '@/shared/lib/navigation';

export const personalRoute = createMetaRoute<RouteMeta>();
export const historyRoute = createMetaRoute<RouteMeta>();
